module.exports = __webpack_public_path__ + "img/portrait-052.28479b9e.jpg";